import { DataFormats } from '@skylab-shared/constants';
import { ConsoleLogger, Query, QueryHandler } from '@skylab-shared/core';
import { BankAccountStatus } from '@skylab-shared/dataModel';
import * as axios from 'axios';
import { format } from 'fecha';
import { NrbUtils } from '../../common/nrb-utils';
import { NipValidator } from '../../common/validators/nip-validator';
import { NrbValidator } from '../../common/validators/nrb-validator';
import { WHITE_LIST_API } from './white-list-api';

enum BankAccountExists {
    Yes = 'TAK',
    No = 'NIE'
}

export interface CheckClientBankAccountQueryResponse {
    requestId: string;
    status: BankAccountStatus;
}

export class CheckClientBankAccountQuery extends Query<CheckClientBankAccountQueryResponse> {
    public constructor(
        public nip: string,
        public bankAccount: string) {
        super();
    }
}

export class CheckClientBankAccountQueryHandlerBase implements QueryHandler<CheckClientBankAccountQuery, CheckClientBankAccountQueryResponse> {
    private logger = new ConsoleLogger(this.constructor.name);

    public async handleAsync(query: CheckClientBankAccountQuery): Promise<CheckClientBankAccountQueryResponse> {
        try {
            const bankAccount = NipValidator.isValid(query.nip) && NrbValidator.isValid(query.bankAccount) && this.prepareNumber(query.bankAccount);
            if (bankAccount) {
                const response = await axios.default.get<unknown>(`${WHITE_LIST_API}/check/nip/${query.nip}/bank-account/${bankAccount}`, {
                    params: {
                        date: this.getWhiteListRequestValidDate(),
                    },
                });
                if (response.status === 200) {
                    const data = this.checkBankAccount(response.data);
                    return data;
                }
            }
            return {
                status: BankAccountStatus.Unverified,
                requestId: ''
            };

        } catch (err) {
            this.logger.error(err);
            return {
                status: BankAccountStatus.Unverified,
                requestId: ''
            };
        }
    }

    private checkBankAccount(data: any): CheckClientBankAccountQueryResponse {
        const result = data.result;
        return {
            status: result.accountAssigned === BankAccountExists.Yes ? BankAccountStatus.Present : BankAccountStatus.Missing,
            requestId: result.requestId
        };
    }

    private getWhiteListRequestValidDate(): string {
        return format(new Date(), DataFormats.date.webApi);
    }

    private prepareNumber(number: string): string | null {
        let bankAccount = number.replace(/\s/g, '');
        if (NrbUtils.isIBAN(bankAccount, 'PL')) {
            bankAccount = NrbUtils.extractNrb(bankAccount);
        } else if (NrbUtils.isIBAN(bankAccount)) {
            return null;
        }
        return bankAccount;
    }
}

// example data:
// {
//     "result" : {
//       "accountAssigned" : "TAK",
//       "requestId" : "d2n10-84df1a1"
//     }
//   }
